var _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrcDest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E1EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17538 8.13422V22.2647H23.8224V8.13422L15.1268 4.42578L6.17538 8.13422Z",
    fill: "#50B2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03118 11.2031V22.2645H21.9059V11.2031H8.03118Z",
    fill: "#518BB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83778 9.20405L16.7892 5.1903L14.9989 4.42578L6.17538 8.12098V22.2647H7.51809L7.83778 9.20405Z",
    fill: "#249FC7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3312,
    y: 14.082,
    width: 4.21995,
    height: 4.09207,
    fill: "#FFDE7C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3312,
    y: 14.082,
    width: 0.720479,
    height: 4.09207,
    fill: "#FFC824"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9789,
    y: 14.082,
    width: 1.23511,
    height: 1.57387,
    fill: "#FFC824"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1243,
    y: 14.082,
    width: 4.21995,
    height: 4.09207,
    fill: "#FFDE7C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1243,
    y: 14.082,
    width: 0.720479,
    height: 4.09207,
    fill: "#FFC824"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.772,
    y: 14.082,
    width: 1.23511,
    height: 1.57387,
    fill: "#FFC824"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.03132,
    y: 18.1836,
    width: 4.21995,
    height: 4.09207,
    fill: "#FFDE7C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.03132,
    y: 18.1836,
    width: 0.720479,
    height: 4.09207,
    fill: "#FFC824"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.67902,
    y: 18.1836,
    width: 1.23511,
    height: 1.57387,
    fill: "#FFC824"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8245,
    y: 18.1836,
    width: 4.21995,
    height: 4.09207,
    fill: "#FFDE7C"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8245,
    y: 18.1836,
    width: 0.720479,
    height: 4.09207,
    fill: "#FFC824"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4722,
    y: 18.1836,
    width: 1.23511,
    height: 1.57387,
    fill: "#FFC824"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6187,
    y: 18.1836,
    width: 4.21995,
    height: 4.09207,
    fill: "#FFDE7C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6187,
    y: 18.1836,
    width: 0.720479,
    height: 4.09207,
    fill: "#FFC824"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2664,
    y: 18.1836,
    width: 1.23511,
    height: 1.57387,
    fill: "#FFC824"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6.62392,
    y: 21.3086,
    width: 17.1995,
    height: 0.959079,
    fill: "#249FC7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 13.144,
    y: 7.17578,
    width: 4.15601,
    height: 0.639386,
    rx: 0.319693,
    fill: "#107EA3"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0793,
    y: 8.33203,
    width: 4.15601,
    height: 0.639386,
    rx: 0.319693,
    fill: "#107EA3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0793,
    y: 9.48047,
    width: 4.15601,
    height: 0.639386,
    rx: 0.319693,
    fill: "#107EA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcDest);
export default __webpack_public_path__ + "static/media/src-dest.6ef28cea9c63a357bce115625455a67c.svg";
export { ForwardRef as ReactComponent };